import moment from 'moment';
import { MessageBox } from 'element-ui'
//计算金额总合计
export const countMoney = (list, prop) => {
  let sum = 0;
  list.map(function (item) {
    if (!!Number(item[prop])) {
      sum += parseFloat((Number(item[prop])) * 1000) / 1000
    }
  })
  return sum.toFixed(2) * 1
}

//计算数组的某个值的和
export const countNum = (list, prop) => {
  return list.reduce((sum, item) => {
    const num = Number(item[prop]);
    const multiplier = Math.pow(10, 10);
    return isNaN(num) ? sum : (Math.round(sum * multiplier) + Math.round(num * multiplier)) / multiplier;
  }, 0);
}
//计算两个数的差值，保留precision位小数
export const preciseSubtract = (a, b, precision = 10) => {
  const multiplier = Math.pow(10, precision);
  let res = (Math.round(a * multiplier) - Math.round(b * multiplier)) / multiplier;
  return res;
}

//当天的日期  YYYY-MM-DD
export const getToday_ = () => {
  const start = new Date().getTime(); // 默认明天
  return moment(start).format("YYYY-MM-DD");;
}

/**
 * @param {Blob|File|string} data - 文件数据（Blob/File/URL）
 * @param {string} filename - 下载文件名
 */

export const downloadFile = (data, filename) => {
  if (typeof data === 'string') {
    // 处理URL下载（强制文件名）
    fetch(data)
      .then(res => res.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          URL.revokeObjectURL(url)
          document.body.removeChild(link)
        }, 100)
      })
  } else {
    // 处理Blob/File（原逻辑不变）
    const url = URL.createObjectURL(data)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    setTimeout(() => {
      URL.revokeObjectURL(url)
      document.body.removeChild(link)
    }, 100)
  }
}
 
//将this.$confirm封装成Promise形式;简化多次提示的时候代码
export const confirmPromise = (message, title, options = {}) => {
  return new Promise((resolve) => {
    MessageBox.confirm(message, title, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      ...options
    }).then(() => {
      resolve(true) // 用户点击确定
    }).catch(() => {
      resolve(false) // 用户点击取消或关闭对话框
    })
  })
}
